<template>
<div class="app-container" v-loading="loading">
  <div class="content">
    <div>
      <div class="header-nav">
        <div class="left">
          <div class="back-btn" @click="popBack">
            <i class="el-icon-back"></i>
          </div>
          <div class="list-title">DCP列表</div>
        </div>
        <div class="headerIcon">
          <a :href="reportUrl">报告</a>
          <a :href="loadingUrl">二维码</a>
        </div>
      </div>
      <template v-for="dcp in dcpList">
        <div class="list-item" @click="getDcpPermissionAndShowDcpOperation(dcp)" :key="dcp.id">
          <span>{{getDcpName(dcp)}}</span>
          <div class="mark">
            <span :class="{ hasState: dcp.data_status }" :style="{ backgroundColor: dcp.data_status }"></span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </template>
    </div>

    <el-dialog
      top="20vh"
      width="300px"
      title="选择DCP操作"
      :visible.sync="dcpOperationDialogVisible"
    >
      <div class="dcp-option-container">
        <div class="dcp-option" @click="dcpCreate">新建</div>
        <div class="dcp-option" @click="dcpDataList">记录列表</div>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>

import Axios from 'axios'
const axios = Axios.create({ })
import utils from '@/utils/domain';

export default {
components: {

},
data() {
  return {
    dcpList: [],
    loading: false,
    projectId: "",
    uuid: "",
    reportUrl: "",
    dcpOperationDialogVisible: false,
    selectedDCP: undefined,
    adminToken: "",
    proDcpList: [
      {
        data_status: 'RED',
        dcp_instance_uuid:  '20001000-15af-40bf-b39a-41db01200005',
        dcp_type: 'scene',
        project_uuid: '1568760A-BC88-CE1B-4A93-21205B400001',
        settle_period: 'WEEKLY',
      },
      {
        data_status: 'GREEN',
        dcp_instance_uuid:  '20001000-3d24-4fe5-88ec-53f401200005',
        dcp_type: 'scene',
        project_uuid: '1568760A-BC88-CE1B-4A93-21205B400001',
        settle_period: 'WEEKLY',
      }
    ],
  };
},
computed: {
  loadingUrl() {
    const { landingPageURL } = utils.getVtrustDomain();
    return landingPageURL + '/project?uuid=' + this.uuid;
  },
},
watch: {

},
methods: {
  getUrlParams(name) {
      let query = window.location.search.substring(1)
      let res = {}
      window.location.search
        .substring(1)
        .split('&')
        .forEach((item) => {
          let [key, val] = item.split('=')
          key && (res[key] = val)
        })
      return name ? res[name] : res
    },
  getVtrustLogin() {
    // let token = this.getUrlParams('token')
    const token = this.$store.state.loginToken || this.getUrlParams('token');
    axios.defaults.withCredentials = true;
    const { baseURL, adminURL, serviceID } = utils.getVtrustDomain();
    let authLoginUrl = baseURL + '/api/auth/mini-program-login';
    token && axios({
        url: authLoginUrl,
        method: 'POST',
        data: {
          token,
        }
    })
    .then(({ data }) => {
      this.loading = false;
      this.adminToken = data.data.token;
      this.reportUrl = adminURL + `?token=${this.adminToken}&projectUUID=${this.uuid}&loginSource=WORKAPP&serviceId=${serviceID}&redirect=report`;
      console.log(this.reportUrl, 'reportUrl');
      let dcpsUrl = baseURL + '/api/admin/project/dcps';
      token && axios({
          url: dcpsUrl,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.adminToken ? `Bearer ${this.adminToken}` : {}, 
          },
          params: {
            project_uuid: this.uuid,
          }
      })
      .then(({ data }) => {
        this.loading = false;
        // this.proDcpList = data.data;
        console.log(this.dcpList, 'this.proDcpList');

        // 合并数据，匹配dcp_instance_uuid 和 instanceUuid，匹配成功设置颜色
        if (this.proDcpList.length > 0) {
          const currDcpList = [...this.dcpList];
          for(let i = 0;i < this.proDcpList.length;i ++){
            const curr = this.proDcpList[i];
            const dcpUuid = curr.dcp_instance_uuid;
            const dataStatus = curr.data_status;
            currDcpList.map(item => {
              if (item.instanceUuid === dcpUuid) {
                item.data_status = dataStatus;
                return;
              }
            });
          }
          this.dcpList = currDcpList;
        }
        
        console.log(this.dcpList, 'this.proDcpList');
      })
      .catch(( error ) => {
        this.loading = false;
      })
    })
    .catch(( error ) => {
      this.loading = false;
    })
  },
  popBack() {
    this.$router.back()
  },
  getDcpName(dcp){
    let processDetail = dcp.processDetail
    if(processDetail && processDetail.dataModelInfos && Array.isArray(processDetail.dataModelInfos)){
      return processDetail.dataModelInfos[0].modelName || processDetail.processName
    }
    return processDetail && processDetail.processName || ""
  },
  getDCPList() {
      this.loading = true
      let token = this.$store.state.loginToken || this.getUrlParams('token')

      axios.defaults.withCredentials = true
      // let data = {
      //   projectId: this.projectId
      // }
      token && axios({
        url: utils.getDomain() + '/workspace/dataPointList',
        method: 'POST',
        headers: {
          'x-api-token': token,
          'Content-Type':'application/json'
        },
        params: {
          projectId: this.projectId
        }
      })
      .then(({ data }) => {
        // console.log("resp_data", data)
        this.loading = false
        if(data.code === 'common.success') {
          this.dcpList = data.data
        }
      })
      .catch(( error ) => {
        this.loading = false
        // console.log("error_occur", error)
      })
  },
  dcpDetail(project){
    console.log("select-bu", project)
    let buId = this.buId
    this.$router.push({path: "/projectdcplist", query: {
      projectId: project.id
    }})
  },
  getDcpPermissionAndShowDcpOperation(dcp) {
      this.selectedDCP = dcp
      this.dcpOperationDialogVisible = true
  },
  dcpCreate() {
      this.dcpOperationDialogVisible = false
      /// get dcp detail and enter dcp detail page
      let token = this.$store.state.loginToken || this.getUrlParams('token');
      let processCode = this.selectedDCP && this.selectedDCP.processDetail && this.selectedDCP.processDetail.processCode
      let modelInfos = this.selectedDCP && this.selectedDCP.processDetail && this.selectedDCP.processDetail.dataModelInfos || []
      let modelUuid = modelInfos[0].modelUuid
      let version = this.selectedDCP && this.selectedDCP.version || ""
      axios.defaults.withCredentials = true

      this.loading = true
      token && axios({
        url: utils.getDomain() + '/builderapp/dcpDetail',
        method: 'GET',
        headers: {
          'x-api-token': token,
          'Content-Type':'application/json'
        },
        params: {
          processCode,
          modelUuid,
          version
        }
      })
      .then(({ data }) => {
        // console.log("resp_data", data)
        this.loading = false
        if(data.code === 'common.success') {

          this.$store.state.wechat.dcpTemplate = data.data.modelDetail.model

          /// update datamodel uuid, instanceUuid
          this.updateStore()

          this.$router.push({path: '/v2/', query:{ wechat: true }})
        }
      })
      .catch(( error ) => {
        this.loading = false
        // console.log("error_occur", error)
      })
  },
  updateStore() {
      let modelInfos = this.selectedDCP && this.selectedDCP.processDetail && this.selectedDCP.processDetail.dataModelInfos || []
      let modelUuid = modelInfos[0].modelUuid
      this.$store.state.wechat.datamodelUuid = modelUuid
      this.$store.state.wechat.instanceUuid = this.selectedDCP && this.selectedDCP.instanceUuid
      this.$store.state.wechat.processCode = this.selectedDCP && this.selectedDCP.processDetail && this.selectedDCP.processDetail.processCode
      this.$store.state.wechat.version = this.selectedDCP && this.selectedDCP.version || ""
  },
  dcpDataList() {
      this.dcpOperationDialogVisible = false
      /// update datamodel uuid, instanceUuid
      
      // console.log("this.selectedDp", this.selectedDCP)
      // console.log("modelUuid", modelUuid)
      this.updateStore()
      this.$router.push({path: '/dcpdatalist', query:{ wechat: true }})
  }
},
created() {

},
mounted() {
  /// get token from url , and request bu list
  this.projectId = this.$route.query.projectId;
  this.$store.state.wechat.projectId = this.projectId;
  this.uuid = this.$route.query.uuid;
  this.getDCPList();
  this.getVtrustLogin();
},
}
</script>

<style lang="scss" scoped>
  .app-container {
    font-size: 16px;
    width: 100vw;
    max-width: 750px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .content {
      flex: 1;

      .header-nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        i {
          width: 20px;
          height: 20px;
        }
        .back-btn {
          padding: 10px;
          height: 20px;
          font-size: 16px;
        }
      }

      .headerTop {
        display: flex;
      }
      
      .headerIcon {
        margin-right: 20px;
      }

      .headerIcon a {
        padding-right: 10px;
      }

      .list-title {
        padding: 10px;
        height: 20px;
        color: #999;
        font-size: 16px;
        margin-left: 10px;
        // position: sticky;
      }

      .hasState {
        display: inline-block;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        margin-right: 15px;
      }

      .list-item {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin: 10px;
        margin-top: 15px;
        width: calc(100vw - 40px);
        max-width: 750px;
        box-shadow: 0 0 0 2px #ffffff, 0 0 6px 3px #cccccc;
      }
    }
  }

  .dcp-option-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .dcp-option {
      height: 20px;
      margin: 10px;
    }
  }
</style>